/* eslint-disable max-lines */
import { Injectable } from '@angular/core';
import {
  LoginFormValidate,
  validateQuestionAnswer
} from '@com-delta-idp/mnx-login-ui';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { LoginHelperUtils } from '../../../utils/login-helper.utils';
import { RecoverSQAAdapterService } from '../../adapters/recover-sqa-adapter/recover-sqa-adapter.service';
import { ANALYTICS_EVENTS_LOGIN } from '../../constants/analytics-constants';
import { VIEW_NAME } from '../../constants/login-constant';
import {
  SQAuthenticationScreen,
  validateAnswerRequest
} from '../../models/recover-by-sqa.interface';
import { LoginContentService } from '../../services';
import { NextDisplayViewService } from '../../services/next-display-view.service';
import { RecoverSqaContentService } from '../../services/recover-sqa-service/recover-sqa-content.service';
import { RecoverSqaHelperService } from '../../services/recover-sqa-service/recover-sqa-helper.service';
import { CreateMyPasswordFacade } from '../create-my-password/create-my-password.facade';
import { RecoverSqaFacadeHelperService } from './recover-sqa-facade-helper.service';
@Injectable({
  providedIn: 'root'
})
export class RecoverSQAFacadeService extends RecoverSqaFacadeHelperService {
  sqaRecoveryScreenContent: SQAuthenticationScreen =
    {} as SQAuthenticationScreen;

  unsubscribe = new Subject<void>();
  constructor(
    protected sqacontentService: RecoverSqaContentService,
    protected recoverSQAAdapterService: RecoverSQAAdapterService,
    protected nextDisplayViewService: NextDisplayViewService,
    protected loginHelperUtils: LoginHelperUtils,
    protected helper: RecoverSqaHelperService,
    protected createMyPasswordFacade: CreateMyPasswordFacade,
    protected loginContentService: LoginContentService
  ) {
    super();
    this.getPageContent();
  }

  getPageContent() {
    this.loginContentService.getAEMContent().subscribe(
      async (response) => {
        this.aemContent = response;
      },
      (err) => this.handleError(err?.error?.errors)
    );
  }

  async getSQADetails() {
    this.sqacontentService.getStoredQuestions().subscribe(
      async (response) => {
        if (response?.errors && response.errors.length > 0) {
          this.handleErrorSecurityQuestions(response?.errors[0]?.code);
        } else if (!response?.securityQuestionList) {
          this.sqaError$.next(this.handleDefaultSQAError());
        } else {
          this.secretQuestions = response;
          this.sqaRecoveryScreenContent =
            await this.recoverSQAAdapterService.recoverSQAAdapterScreenContent(
              this.aemContent,
              this.secretQuestions
            );
          this.pageContent$.next(this.sqaRecoveryScreenContent);
          this.analytics.dispatchCustomEvent(
            ANALYTICS_EVENTS_LOGIN.SECURITY_QUESTIONS_ANSWERS_LOADED,
            true
          );
          this.nextDisplayViewService.nextDisplayView(
            VIEW_NAME.SECURITY_QUESTION_ANSWER_SCREEN
          );
        }
      },
      (err) => this.handleError(err?.error?.errors)
    );
  }

  onFormSubmit(submit = false, userInputFields: validateQuestionAnswer) {
    if (submit) {
      this.getSecurityContent()
        .formGroup.get('answer2')
        ?.updateValueAndValidity();
      LoginFormValidate.sqaControlsOnSubmit(this.getSecurityContent());
      this.getSecurityContent().sqaFormAttributes.submitAttempt = true;
      if (this.getSecurityContent().formGroup.valid) {
        this.setActionButtonDisable(true);
        this.getSecurityContent().errorCode = undefined;
        const request = {
          tlMaskInfo_answer1: this.getSecurityContent()
            .formGroup.get('answer1')
            ?.value?.value?.trim(),
          tlMaskInfo_answer2: this.getSecurityContent()
            .formGroup.get('answer2')
            ?.value?.value?.trim(),
          formNameSubmitted: 'resetPassword',
          securityQuestionNbr1: userInputFields.securityQuestionNbr1,
          securityQuestionNbr2: userInputFields.securityQuestionNbr2
        };
        this.recoverSQAPostWithBFF(request);
      } else {
        this.getSecurityContent().sqaFormAttributes.errorCount =
          LoginFormValidate.validateFormFields(
            this.getSecurityContent().formGroup
          );
        this.getSecurityContent().sqaFormAttributes.errorAlertBanner =
          LoginFormValidate.getErrorAlert(this.getSecurityContent().formGroup);
        LoginFormValidate.touchSecurityControlsOnSubmit(
          this.getSecurityContent()
        );
      }
    }
  }

  recoverSQAPostWithBFF(userInputFields: validateAnswerRequest) {
    if (this.helper.validityCheckForFormSubmit(userInputFields)) {
      this.sqacontentService
        .validateSecurityQuestions(userInputFields)
        .pipe(
          takeUntil(this.unsubscribe),
          finalize(() => {
            this.setActionButtonDisable(false);
          })
        )
        .subscribe(
          (response) => {
            if (response?.errors) {
              this.handleSqaResponseErrors(response?.errors);
            } else if (response?.isSuccess) {
              this.resetRecoverSQAForm();
              const {
                nextDisplayView: { nextViewName }
              } = this.getSecurityContent().pageContent;
              this.createMyPasswordFacade.setUserName(response);
              this.createMyPasswordFacade.resetForm();
              this.analytics.dispatchCustomEvent(
                ANALYTICS_EVENTS_LOGIN.SET_PASSWORD_LOADED,
                true
              );
              this.nextDisplayViewService.nextDisplayView(nextViewName);
            } else {
              this.handleDefaultError();
            }
          },
          (error) => {
            if (error?.error?.errors[0]?.code) {
              this.handleError(error?.error?.errors);
            } else {
              this.handleDefaultError();
            }
          }
        );
    }
  }
}
